var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.999,
    height: 223.943,
    viewBox: "0 0 299.999 223.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .no-data-cls-1 {\r\n        fill: #f3f3f1;\r\n      }\r\n\r\n      .no-data-cls-2 {\r\n        fill: #d4d4d4;\r\n      }\r\n\r\n      .no-data-cls-3 {\r\n        fill: #d5dbe1;\r\n      }\r\n\r\n      .no-data-cls-4 {\r\n        fill: #adadad;\r\n      }\r\n\r\n      .no-data-cls-5 {\r\n        fill: #5e94fd;\r\n      }\r\n\r\n      .no-data-cls-6 {\r\n        fill: #5d94fd;\r\n        stroke: #5e94fd;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521",
    transform: "translate(-135.923 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6520",
    "data-name": "Group 6520",
    transform: "translate(135.923 346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5813",
    "data-name": "Path 5813",
    className: "no-data-cls-1",
    d: "M306.937,266.667V327.6a18.805,18.805,0,0,1-18.75,18.75H114.75A18.805,18.805,0,0,1,96,327.6V266.667h35.25a9.253,9.253,0,0,1,8.906,6.656l10.125,33.563a9.253,9.253,0,0,0,8.906,6.656h84.562a9.253,9.253,0,0,0,8.906-6.656l10.125-33.563a9.253,9.253,0,0,1,8.906-6.656Z",
    transform: "translate(-51.469 -129.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5814",
    "data-name": "Path 5814",
    className: "no-data-cls-2",
    d: "M306.937,218.194h-35.25a9.253,9.253,0,0,0-8.906,6.656l-10.125,33.563a9.253,9.253,0,0,1-8.906,6.656H159.187a9.253,9.253,0,0,1-8.906-6.656L140.156,224.85a9.253,9.253,0,0,0-8.906-6.656H96l42.187-93.75H264.749Z",
    transform: "translate(-51.469 -80.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    className: "no-data-cls-3",
    d: "M117.094,327.6V266.667H96V327.6a18.805,18.805,0,0,0,18.75,18.75h21.094A18.805,18.805,0,0,1,117.094,327.6Z",
    transform: "translate(-51.469 -129.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    className: "no-data-cls-4",
    d: "M138.187,124.444,96,218.194h21.094l42.187-93.75Z",
    transform: "translate(-51.469 -80.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5817",
    "data-name": "Path 5817",
    className: "no-data-cls-4",
    d: "M189.6,306.885l-10.125-33.563a9.253,9.253,0,0,0-8.906-6.656H149.476a9.253,9.253,0,0,1,8.906,6.656l10.125,33.563a9.253,9.253,0,0,0,8.906,6.656h21.094A9.253,9.253,0,0,1,189.6,306.885Z",
    transform: "translate(-69.695 -129.442)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6518",
    "data-name": "Group 6518",
    transform: "translate(197.402 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5818",
    "data-name": "Path 5818",
    className: "no-data-cls-5",
    d: "M389.843,78.374l-6.628-6.628L396.471,58.49l6.628,6.628Z",
    transform: "translate(-346.76 -58.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5819",
    "data-name": "Path 5819",
    className: "no-data-cls-5",
    d: "M399.006,136.209l-13.257-13.256,6.628-6.628,13.257,13.256Z",
    transform: "translate(-347.624 -78.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5820",
    "data-name": "Path 5820",
    className: "no-data-cls-5",
    d: "M341.168,78.381,327.912,65.125,334.54,58.5,347.8,71.753Z",
    transform: "translate(-327.912 -58.492)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5821",
    "data-name": "Path 5821",
    className: "no-data-cls-5",
    d: "M284.552,301.277H111.114A25.8,25.8,0,0,1,85.333,275.5V214.559a6.982,6.982,0,0,1,.619-2.888l42.187-93.75a7.032,7.032,0,0,1,6.412-4.144H261.114a7.032,7.032,0,0,1,6.412,4.144l42.187,93.75a6.982,6.982,0,0,1,.619,2.888V275.5A25.8,25.8,0,0,1,284.552,301.277ZM99.4,216.068V275.5a11.735,11.735,0,0,0,11.718,11.719H284.552A11.735,11.735,0,0,0,296.27,275.5V216.068l-39.7-88.227H139.1Z",
    transform: "translate(-47.833 -77.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5822",
    "data-name": "Path 5822",
    className: "no-data-cls-5",
    d: "M243.712,316.937H159.225a16.31,16.31,0,0,1-15.713-11.69l-10.059-33.506a2.369,2.369,0,0,0-2.24-1.678H96V256h35.213a16.309,16.309,0,0,1,15.712,11.691l10.06,33.506a2.356,2.356,0,0,0,2.241,1.678h84.487a2.347,2.347,0,0,0,2.241-1.678l10.06-33.506A16.3,16.3,0,0,1,271.724,256h35.213v14.062H271.724a2.349,2.349,0,0,0-2.24,1.678l-10.059,33.506A16.31,16.31,0,0,1,243.712,316.937Z",
    transform: "translate(-51.469 -125.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5823",
    "data-name": "Path 5823",
    className: "no-data-cls-5",
    d: "M28.444,376.889h300v14.062h-300Z",
    transform: "translate(-28.444 -167.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    className: "no-data-cls-5",
    cx: 9.383,
    cy: 9.383,
    r: 9.383,
    transform: "translate(114.249 80.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    className: "no-data-cls-5",
    cx: 9.383,
    cy: 9.383,
    r: 9.383,
    transform: "translate(170.939 80.967)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    className: "no-data-cls-6",
    cx: 7.229,
    cy: 13.476,
    rx: 7.229,
    ry: 13.476,
    transform: "translate(145.372 118.259)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519",
    transform: "translate(45.299 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5824",
    "data-name": "Path 5824",
    className: "no-data-cls-5",
    d: "M99.7,65.118l6.628-6.628,13.256,13.256-6.628,6.628Z",
    transform: "translate(-98.028 -58.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5825",
    "data-name": "Path 5825",
    className: "no-data-cls-5",
    d: "M97.164,129.581l13.256-13.256,6.628,6.628-13.256,13.256Z",
    transform: "translate(-97.164 -78.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5826",
    "data-name": "Path 5826",
    className: "no-data-cls-5",
    d: "M155,71.753,168.258,58.5l6.628,6.628L161.63,78.381Z",
    transform: "translate(-116.876 -58.492)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.svg";
export { ForwardRef as ReactComponent };